import '../styles/Loader.css'

export const LoaderRedux = () => {
  return (
    <div className='overlay-spinner'>
      <div className='loader-in'>
        <div className='spinner'></div>
      </div>
    </div>
  )
}
